var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListDone = function SvgListDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.72 5.68-1.44-1.36-4.24 4.24-2.32-2.24-1.44 1.36 3.76 3.76zm.32 9.28h-6v-2h6zm-10 0h2v-2h-2zm10 4h-6v-2h6zm-10 0h2v-2h-2zM0 11.44q0 4.32.56 8.4.24 2 .56 3.12l17.76.08.32-1.52q.32-1.84.48-4 .32-3.04.32-6.12t-.32-5.8a28 28 0 0 0-.48-3.44l-.32-1.2H1.12L.8 2.16A28 28 0 0 0 .32 5.6 50 50 0 0 0 0 11.44m17.44 8.08q-.08.72-.24 1.52H2.72l-.16-1.52A58.5 58.5 0 0 1 2 11.4q0-4.12.56-7.48l.16-.96h14.56l.16.96Q18 7.2 18 11.4t-.56 8.12"
  })));
};
export default SvgListDone;